var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStickerActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2734 0C10.2689 0.140227 10.2666 0.282376 10.2666 0.425781C10.2668 8.67309 16.9529 15.3594 25.2002 15.3594C26.1251 15.3594 27.0292 15.2723 27.9062 15.1113C27.1053 22.0824 21.1856 27.4961 14 27.4961C6.26802 27.4961 1.88618e-05 21.2281 0 13.4961C0 7.22273 4.126 1.91347 9.8125 0.133789L10.2734 0Z",
    fill: "#253FF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1367 0.617188C13.238 0.631315 14.3555 1.14597 15.3057 1.98828L26.1064 11.5625C26.6741 12.0659 27.0148 12.7067 27.0576 13.3564C26.4504 13.4436 25.8307 13.4932 25.2002 13.4932C18.0477 13.4932 12.2393 7.7453 12.1367 0.617188Z",
    fill: "#253FF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickerActive);
export default __webpack_public_path__ + "static/media/sticker-active.10f67ead0a5596406002bfb27b0a9730.svg";
export { ForwardRef as ReactComponent };